import { useEffect } from "react";

import { identifyAnalyticsUser } from "@common/analytics/ga4";
import { useAuthContext } from "@main/context/Auth/Auth.context";

export const useAnalyticsIdentify = () => {
  const { userData } = useAuthContext();

  useEffect(() => {
    if (!userData?.id) return;
    identifyAnalyticsUser(userData.id);
  }, [userData?.id]);
};
